import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">About</h1>
      <p>Do you need to send evidence to Darlington Borough Council to support an application?</p>
      <p>Use Darlington MyScan to submit your paperwork to us. It's easy to use, secure and best of all you can do it from the comfort of your own home. No need to travel to our offices, no more queues and avoid having to book an appointment. Its easy to use, secure and best of all you can do it from the comfort of your own home 24/7 365 days of the year.</p>
      <p>All you need is an internet connection and a device that can scan or take pictures.</p>
      <br />
      <p><strong>Evidence submissions cover only Darlington Borough Council area at the moment.</strong></p>

    </React.Fragment>
  );
};
